import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import BadEntityAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/bad-condition/bad-condition.entity';
import { CompanyService } from '../../configuration/company/company.service.service';
import { BadConditionService } from './bad-condition-motive.service';
import { ICreateBadCondition } from './interfaces/create-bad-condition.interface';
import { IUpdateBadCondition } from './interfaces/update-bad-condition.interface';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-condition',
  templateUrl: './bad-condition-motive.component.html',
  styleUrl: './bad-condition-motive.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class BadConditionMotiveComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "status", "actions"];
  currentCreateBadCondition: ICreateBadCondition = this.initializeCreateBadCondition();
  currentUpdateBadCondition: BadEntityAttributes | undefined;

  dataSource: BadEntityAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number[] = [1, 0];

  companyForm = new FormGroup({
    companyId: new FormControl(null),
  });
  
  constructor(
    private readonly conditionService: BadConditionService,
    private companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) { }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    this.fetchAllCompanies();
  }


  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }


  private initializeCreateBadCondition(): ICreateBadCondition {
    return { name: "" , companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";

    this.conditionService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        [this.companyForm.value.companyId],
        this.selectedStatuses
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof BadEntityAttributes {
    const validSortFields: (keyof BadEntityAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof BadEntityAttributes) ? (this.sort.active as keyof BadEntityAttributes) : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: BadEntityAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.currentCreateBadCondition = this.initializeCreateBadCondition();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBadCondition());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: BadEntityAttributes): void {
    this.currentUpdateBadCondition = { ...condition };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateBadCondition(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBadCondition(): void {
    this.conditionService.create(this.currentCreateBadCondition).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateBadCondition(id: string): void {
    if (this.currentUpdateBadCondition) {
      const updatedBadCondition: IUpdateBadCondition = { ...this.currentUpdateBadCondition,
        companyId: this.currentUpdateBadCondition.company._id.toString(),
       };

      this.conditionService.update(id, updatedBadCondition).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, condition: BadEntityAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBadCondition = { ...condition, statusId: updatedStatusId };

    this.conditionService.update(condition._id.toString(), updatedBadCondition).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        condition.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(condition: BadEntityAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.conditionService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  
  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdateBadCondition) {
      this.currentUpdateBadCondition.company = this.companyList.find(
        (company) => company._id.toString() === companyId
      )!;
    }
  }


  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  applyStatusFilter(): void {
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }
}
